var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.servicePhone)?_c('my-drag',[(_vm.telNumber)?_c('a',{staticClass:"global-service",attrs:{"href":'tel:' + _vm.telNumber}},[_c('span',{staticClass:"iconfont icon-phone"}),_c('span',[_vm._v("客服")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }